import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  id: "joy-sidebar-content",
  class: "_content"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  id: "joy-sidebar-bottom",
  class: "_bottom"
}, null, -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (!_ctx.isLeftSidebarDisabled)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["joy-left-sidebar", { _pinned: _ctx.isLeftSidebarPinned }])
      }, [
        _createElementVNode("div", {
          class: "_collapse-btn",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)), ["stop"]))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: "angle-left",
            size: "1x"
          })
        ]),
        _createElementVNode("div", {
          class: "_inner",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
        }, _hoisted_3)
      ], 2))
    : _createCommentVNode("", true)
}